<template>
<div class="row clearfix">
  <div v-if="loading">
    <BlockUI :message="blockuimsg"></BlockUI>
  </div>
  <div class="col-lg-12">
    <b-row>
        <b-col style="text-align:center">
          <h3>Recursos / Unidades</h3>
        </b-col>
    </b-row>
    <div class="card">
      <div class="tab-content">
        <div class="table-responsive">
          <div class="d-flex justify-content-between align-items-center mb-4 pl-4">
            <b-pagination class="p-0 m-0"
              v-model="currentPage"
              :total-rows="rows"
              :per-page="perPage"
              aria-controls="my-table">
            </b-pagination>
            <div class="d-flex align-items-center pl-3 mr-auto">
              <label class="p-0 m-0 pr-3 text-purple">Filtrar por tags</label>
              <vue-tags-input
                v-model="taglist"
                :autocomplete-items="tagslist"
                :add-only-from-autocomplete="true"
                @tags-changed="updatelist"
              />
            </div>
            <div class="col-md-3">
              <ResourceSearchs :routeApi="'unitmath'" ref="searchcomponent"
                :perPage = "perPage"
                :newTags2 = "newTags2"
                @update="onUpdateDataResource"
                @loading="onLoading"
              />
            </div>
            <b-button @click="onNew" variant="success">
              + Añadir
            </b-button>
          </div>
          <b-table hover :items="resources"
            :fields= fields
            :per-page="0"
            :current-page="currentPage"
            >
            <template v-slot:cell(TEXTO_SINGULAR)="data">
              {{ data.item.TEXTO_SINGULAR[languages.indexOf(languageGlobal)].TEXTO }}
            </template>
             <template v-slot:cell(TEXTO_PLURAL)="data">
              {{ data.item.TEXTO_PLURAL[languages.indexOf(languageGlobal)].TEXTO }}
            </template>
            <template v-slot:cell(reproductor)="row">
              <audio :src="row.item[`AUDIO_SINGULAR_${languageGlobal}`]" controls="controls"
                                style="width:100%" type="audio/mpeg" preload="preload">
              </audio>
            </template>
            <template v-slot:cell(actions)="row">
              <b-button class="btn btn-icon btn-icon-mini btn-round btn-info" @click="info(row.item, row.index, $event.target)">
                <i class="zmdi zmdi-edit"></i>
              </b-button>
              <b-button class="btn btn-icon btn-icon-mini btn-round btn-danger" @click="ondelete(row.item)">
                <i class="fa fa-trash"></i>
              </b-button>
            </template>
          </b-table>
        </div>
      </div>
    </div>
  </div>
  <!-- Info modal -->
    <b-modal :id="infoModal.id" size="xl" :title="infoModal.title" hide-footer>
       <div class="modal-body">
            <b-row>
              <b-col md="6">
                <div>
                  <label>Texto singular</label>
                  <div class="col-md-12 d-inline-flex align-items-center">
                    <input type="text" v-bind:value="getTranslation(selectedItem.text.TEXTO_SINGULAR)"
                    disabled class="form-control" />
                    <searchtexts class="pl-2" idModal="mdlSearchTextSingular"
                      v-on:selected="onSelectedTextSingular($event)">
                    </searchtexts>
                  </div>
                  <div class="col-md-12 ">
                    <b-form-input
                        id="TEXTOS_ID_SINGULAR"
                        v-model="selectedItem.TEXTOS_ID_SINGULAR"
                        placeholder="Nombre..."
                        :state="($v.selectedItem.TEXTOS_ID_SINGULAR.$dirty && submitted)?
                        !$v.selectedItem.TEXTOS_ID_SINGULAR.$error : null"
                        aria-describedby="TEXTOS_ID_SINGULAR-feedback" style="display: none" />
                    <b-form-invalid-feedback id="TEXTOS_ID_SINGULAR-feedback">
                      Este campo es requerido.
                    </b-form-invalid-feedback>
                    </div>
                </div>
                <br/>
                <div>
                  <label>Texto plural</label>
                  <div class="col-md-12 d-inline-flex align-items-center">
                    <input type="text" v-bind:value="getTranslation(selectedItem.text.TEXTO_PLURAL)"
                    disabled class="form-control" />
                    <searchtexts class="pl-2" idModal="mdlSearchTextPlural"
                      v-on:selected="onSelectedTextPlural($event)">
                    </searchtexts>
                  </div>
                  <div>
                    <b-form-input
                        id="TEXTOS_ID_PLURAL"
                        v-model="selectedItem.TEXTOS_ID_PLURAL"
                        placeholder="Nombre..."
                        :state="($v.selectedItem.TEXTOS_ID_PLURAL.$dirty && submitted)?
                        !$v.selectedItem.TEXTOS_ID_PLURAL.$error : null"
                        aria-describedby="TEXTOS_ID_PLURAL-feedback" style="display: none" />
                    <b-form-invalid-feedback id="TEXTOS_ID_PLURAL-feedback">
                      Este campo es requerido.
                    </b-form-invalid-feedback>
                  </div>
                </div>
                <br/>
                <div>
                  <label for="">Símbolo</label>
                  <b-form-input
                    id="SIMBOLO"
                    v-model="selectedItem.SIMBOLO"
                    placeholder="Símbolo..." />
                </div>
                <br>
                <div class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input"
                  v-model="selectedItem.PRE"
                  id="PRE">
                  <label class="custom-control-label" for="PRE">
                    Prefijo Unidad SI/NO</label>
                </div>
              </b-col>
              <b-col md="6">
                <div>
                  <label>Audio singular</label>
                  <div class="col-md-12 d-inline-flex align-items-center">
                    <i class="zmdi zmdi-close-circle pointer pr-2 text-danger" v-if="selectedItem.AUDIOS_ID !== 0 && selectedItem.AUDIOS_ID !== null" @click="cleanAudioS()" />
                    <audio :src="getTranslation(selectedItem.text.AUDIO_SINGULAR)" controls="controls"
                              style="width:100%" type="audio/mpeg" preload="preload" v-if="selectedItem.AUDIOS_ID !== null && selectedItem.AUDIOS_ID !== 0">
                    </audio>
                    <span v-if="selectedItem.AUDIOS_ID === null || selectedItem.AUDIOS_ID === 0">Sin audio</span>
                    <searchaudios class="pl-2" idModal="mdlSearchAudioSingular"
                      v-on:selected="onSelectedAudioSingular($event)">
                    </searchaudios>
                  </div>
                  <label>Audio plural</label>
                  <div class="col-md-12 d-inline-flex align-items-center">
                    <i class="zmdi zmdi-close-circle pointer pr-2 text-danger" v-if="selectedItem.AUDIOP_ID !== 0 && selectedItem.AUDIOP_ID !== null" @click="cleanAudioP()" />
                    <audio :src="getTranslation(selectedItem.text.AUDIO_PLURAL)" controls="controls"
                              style="width:100%" type="audio/mpeg" preload="preload">
                    </audio>
                    <searchaudios class="pl-2" idModal="mdlSearchAudioPlural"
                      v-on:selected="onSelectedAudioPlural($event)">
                    </searchaudios>
                  </div>
                </div>
                <div>
                  <label>Imagen</label>
                  <div class="col-md-12 d-inline-flex align-items-center">
                    <i class="zmdi zmdi-close-circle pointer pr-2 text-danger" v-if="selectedItem.IMAGENES_ID !== 0 && selectedItem.IMAGENES_ID !== null" @click="cleanImage()" />
                    <div class="image">
                                    <img :src="getTranslation(selectedItem.text.IMAGEN)" alt="img"
                                    style="width:110px;height:110px" class="img-fluid">
                    </div>
                    <searchimages class="pl-2" idModal="mdlSearchImage"
                      v-on:selected="onSelectedImage($event)">
                    </searchimages>
                  </div>
                </div>
              </b-col>
            </b-row>
            <br/>
            <b-row>
              <b-col>
                <label for="Tag">
                       <br>
                          Etiquetas</label>
                            <div>
                            <vue-tags-input
                              v-model="tag"
                              :tags="tags"
                              :autocomplete-items="autocompleteItems"
                              @tags-changed="update"
                            />
                          </div>
                </b-col>
              </b-row>
              <div class="modal-footer">
                <button type="button" @click="save"
                class="btn btn-info btn-round waves-effect">
                  Guardar</button>
                <b-button class="btn btn-default btn-round waves-effect" block
                @click="$bvModal.hide('info-modal')">Cerrar</b-button>
            </div>
        </div>
    </b-modal>
</div>

</template>

<script>

import VueTagsInput from '@johmun/vue-tags-input';
import { required } from 'vuelidate/lib/validators';
import searchtexts from '../texts/SearchTexts.vue';
import searchimages from '../images/SearchImages.vue';
import searchaudios from '../audios/SearchAudios.vue';
import ResourceSearchs from '../../../components/panel/ResourceSearchs.vue';
import searchMixin from '../../../mixins/search';
import translationMixin from '../../../mixins/translation';

export default {
  components: {
    VueTagsInput,
    searchtexts,
    searchimages,
    searchaudios,
    ResourceSearchs,
  },
  name: 'gridUnits',
  mixins: [searchMixin, translationMixin],
  data() {
    return {
      perPage: 20,
      rows: 0,
      submitted: false,
      currentPage: 1,
      fields: [
        { key: 'TEXTO_SINGULAR', label: 'Texto Plural' },
        { key: 'TEXTO_PLURAL', label: 'Texto Singular' },
        { key: 'reproductor', label: 'Audio', tdClass: 'tdAudio' },
        { key: 'SIMBOLO', label: 'Símbolo', tdClass: 'tdSimbol' },
        { key: 'actions', label: 'Acciones', tdClass: 'tdActionClass' },
      ],
      resources: [],
      selectedItem: {
        ID: null,
        TEXTOS_ID_SINGULAR: null,
        TEXTOS_ID_PLURAL: null,
        AUDIOS_ID: 0,
        AUDIOP_ID: 0,
        IMAGENES_ID: null,
        SIMBOLO: '',
        PRE: false,
        text: { // Used for display
          TEXTO_SINGULAR: [],
          TEXTO_PLURAL: [],
          AUDIO_SINGULAR: [],
          AUDIO_PLURAL: [],
          IMAGEN: [],
        },
      },
      infoModal: {
        id: 'info-modal',
        title: '',
        content: '',
      },
      tag: '',
      taglist: '',
      tags: [],
      newTags: [],
      newTags2: [],
      tagslist: [],
      autocompleteItems: [],
    };
  },
  validations: {
    selectedItem: {
      TEXTOS_ID_SINGULAR: {
        required,
      },
      TEXTOS_ID_PLURAL: {
        required,
      },
    },
  },
  methods: {
    /**
    * @method onSelectedText
    * @description Al seleccionar un texto
    */
    onSelectedTextSingular(itemSelected) {
      this.selectedItem.TEXTOS_ID_SINGULAR = itemSelected.ID;
      this.selectedItem.text.TEXTO_SINGULAR = [];
      this.setTranslation('TEXTO_', itemSelected, this.selectedItem.text.TEXTO_SINGULAR);
      this.$root.$emit('bv::hide::modal', 'mdlSearchTextSingular');
    },
    onSelectedTextPlural(itemSelected) {
      this.selectedItem.TEXTOS_ID_PLURAL = itemSelected.ID;
      this.selectedItem.text.TEXTO_PLURAL = [];
      this.setTranslation('TEXTO_', itemSelected, this.selectedItem.text.TEXTO_PLURAL);
      this.$root.$emit('bv::hide::modal', 'mdlSearchTextPlural');
    },
    /**
    * @method cleanAudio
    * @description Limpia el audio
    */
    cleanAudioS() {
      this.selectedItem.AUDIOS_ID = null;
      this.selectedItem.text.AUDIO_SINGULAR = [];
    },
    cleanAudioP() {
      this.selectedItem.AUDIOP_ID = null;
      this.selectedItem.text.AUDIO_PLURAL = [];
    },
    /**
    * @method onSelectedAudio
    * @description Al seleccionar un audio
    */
    onSelectedAudioSingular(itemSelected) {
      this.selectedItem.AUDIOS_ID = itemSelected.ID;
      this.selectedItem.text.AUDIO_SINGULAR = [];
      this.setTranslation('FICHERO_', itemSelected, this.selectedItem.text.AUDIO_SINGULAR);
      this.$root.$emit('bv::hide::modal', 'mdlSearchAudioSingular');
    },
    onSelectedAudioPlural(itemSelected) {
      this.selectedItem.AUDIOP_ID = itemSelected.ID;
      this.selectedItem.text.AUDIO_PLURAL = [];
      this.setTranslation('FICHERO_', itemSelected, this.selectedItem.text.AUDIO_PLURAL);
      this.$root.$emit('bv::hide::modal', 'mdlSearchAudioPlural');
    },
    /**
    * @method cleanImage
    * @description Limpia la imagen
    */
    cleanImage() {
      this.selectedItem.IMAGENES_ID = null;
      this.selectedItem.text.IMAGEN = [];
    },
    /**
    * @method onSelectedImage
    * @description Al seleccionar una imagen
    */
    onSelectedImage(itemSelected) {
      this.selectedItem.IMAGENES_ID = itemSelected.ID;
      this.selectedItem.text.IMAGEN = [];
      this.setTranslation('FICHERO_', itemSelected, this.selectedItem.text.IMAGEN);
      this.$root.$emit('bv::hide::modal', 'mdlSearchImage');
    },
    onNew() {
      this.submitted = false;
      this.limpiar();
      this.infoModal.title = 'Nueva Unidad';
      this.$root.$emit('bv::show::modal', this.infoModal.id);
    },
    limpiar() {
      this.selectedItem.ID = null;
      this.selectedItem.text.TEXTO_SINGULAR = [];
      this.selectedItem.text.TEXTO_PLURAL = [];
      this.selectedItem.TEXTOS_ID_SINGULAR = null;
      this.selectedItem.TEXTOS_ID_PLURAL = null;
      this.selectedItem.AUDIOS_ID = 0;
      this.selectedItem.text.AUDIO_SINGULAR = [];
      this.selectedItem.AUDIOP_ID = 0;
      this.selectedItem.text.AUDIO_PLURAL = [];
      this.selectedItem.IMAGENES_ID = null;
      this.selectedItem.text.IMAGEN = [];
      this.selectedItem.SIMBOLO = '';
      this.selectedItem.PRE = null;
      this.tag = '';
      this.tags = [];
    },
    async ondelete(item) {
      const confirmation = await this.$bvModal.msgBoxConfirm('Esta a punto de eliminar un registro ¿Esta seguro?');
      if (confirmation) {
        /** Elimino los tags asociados */
        const url = `Tagsunits/deleteTags/${item.ID}`;
        this.axios.get(url);

        this.loading = true;
        const response = await this.axios.post('unitmath/delete', { ID: item.ID });
        if (response.data.status === 'success') {
          this.loading = false;
          this.$toasted.show('Se elimino el registro seleccionado.', { theme: 'outline', type: 'success', duration: 5000 });
          this.getPostData();
        } else {
          this.loading = false;
          this.$toasted.show(response.data.message, { theme: 'outline', type: 'error', duration: 5000 });
        }
      }
    },
    async info(item, index, button) {
      this.submitted = false;
      this.infoModal.title = 'Editar Unidad';
      this.loading = true;
      try {
        const response = await this.axios.get('unitmath/getunitmath', {
          params: {
            id: item.ID,
          },
        });
        this.selectedItem = response.data.content;
      } catch (e) {
        this.$toasted.show('Ocurrió un error al leer la unidad', { type: 'warning' });
      }
      this.loading = false;
      this.getExistingTags(item.ID);
      this.$root.$emit('bv::show::modal', this.infoModal.id, button);
    },
    async save() {
      this.submitted = true;
      this.$v.selectedItem.$touch();
      if (this.$v.selectedItem.$anyError) {
        return;
      }
      this.loading = true;
      const unitData = {
        ID: this.selectedItem.ID || -1,
        TEXTOS_ID_SINGULAR: this.selectedItem.TEXTOS_ID_SINGULAR,
        TEXTOS_ID_PLURAL: this.selectedItem.TEXTOS_ID_PLURAL,
        AUDIOS_ID: this.selectedItem.AUDIOS_ID,
        AUDIOP_ID: this.selectedItem.AUDIOP_ID,
        IMAGENES_ID: this.selectedItem.IMAGENES_ID,
        SIMBOLO: this.selectedItem.SIMBOLO,
        PRE: this.selectedItem.PRE,
      };
      try {
        const response = await this.axios.post('unitmath/store', unitData);
        if (response.data.status === 'success') {
          // Solo si esta creando agrego el evento
          if (this.selectedItem.ID === -1 || this.selectedItem.ID === null) {
            const bc = new BroadcastChannel('new_resource_unit');
            bc.postMessage({
              ID: response.data.id,
              TEXTO_SINGULAR: this.selectedItem.text.TEXTO_SINGULAR,
              TEXTO_PLURAL: this.selectedItem.text.TEXTO_PLURAL,
              TEXTOS_ID_SINGULAR: this.selectedItem.TEXTOS_ID_SINGULAR,
              TEXTOS_ID_PLURAL: this.selectedItem.TEXTOS_ID_PLURAL,
              AUDIOS_ID: this.selectedItem.AUDIOS_ID,
              AUDIOP_ID: this.selectedItem.AUDIOP_ID,
              IMAGENES_ID: this.selectedItem.IMAGENES_ID,
              SIMBOLO: this.selectedItem.SIMBOLO,
              PRE: this.selectedItem.PRE,
            });
          }

          const url = `Tagsunits/deleteTags/${response.data.id}`;
          const url2 = 'Tagsunits/saveTag';

          this.axios.get(url);
          this.newTags.forEach((a) => {
            this.axios.get(`Tags/findTagByName/${a.text}`,
              { name: a.text }).then((resp) => {
              if (resp.data.status === 'success') {
                this.axios.post(url2, { id: resp.data.id, idtexto: response.data.id });
              } else {
                this.axios.post(url2, { id: a.key, idtexto: response.data.id });
              }
            });
          });

          this.$toasted.show('Los datos se guardaron satisfactoriamente.', { theme: 'outline', type: 'success', duration: 5000 });
          this.$root.$emit('bv::hide::modal', this.infoModal.id);
          this.limpiar();

          // Auto close if coming from a create event
          if (this.bAutoClose) {
            window.open('', '_self').close();
          }

          await this.getPostData();
        } else {
          this.$toasted.show(response.data.message, { theme: 'outline', type: 'error', duration: 5000 });
        }
        this.loading = false;
      } catch (e) {
        const resp = e;
        if (!resp.body.Ok) {
          this.$toasted.show(resp.body.Message, { theme: 'outline', type: 'error', duration: 5000 });
        }
        this.loading = false;
      }
    },
    async getPostData() {
      this.loading = true;

      try {
        const response = await this.axios.get('unitmath', {
          params: {
            currentPage: this.currentPage,
            size: this.perPage,
            newTags: this.newTags2,
            resourcetosearch: this.$refs.searchcomponent.resoursetosearch,
          },
        });

        this.rows = response.data.rows;
        this.resources = Object.keys(response.data.results).map(k => response.data.results[k]);
        this.loading = false;
      } catch (e) {
        this.loading = false;
      }
    },
    updatelist(newTags) {
      this.newTags2 = newTags;
      this.getPostData();
    },
    listTags() {
      const url = 'Tags';
      const datos = [];
      this.axios.get(url).then((res) => {
        res.data.forEach((a) => {
          datos.push({ key: a.ID, text: a.NOMBRE });
        });
        this.tagslist = datos;
      })
        .catch((error) => {
          console.error(error);
        });
      this.loading = false;
    },
    initItems() {
      const url = 'Tags';
      const datos = [];

      this.axios.get(url).then((res) => {
        res.data.forEach((a) => {
          datos.push({ text: a.NOMBRE, key: a.ID });
        });
        this.autocompleteItems = datos;
      }).catch((error) => {
        console.error(error);
      });

      this.loading = false;
    },
    update(newTags) {
      this.tags = newTags;
      this.newTags = newTags;
    },
    async getExistingTags(idtxt) {
      const url = `Tagsunits/findByUnit/${idtxt}`;
      const datos = [];
      this.loading = true;

      try {
        this.axios.get(url).then((res) => {
          res.data.forEach((a) => {
            datos.push({ text: a.NOMBRE, key: a.ID });
          });
          this.tags = datos;
        })
          .catch((error) => {
            console.error(error);
          });
        this.loading = false;
      } catch (e) {
        console.log(e);
        this.loading = false;
      }
    },
  },
  async mounted() {
    await this.getPostData();
    this.initItems();
    this.listTags();

    // Open create modal automatically
    const self = this;
    const bc = new BroadcastChannel('new_resource_unit_open');
    bc.onmessage = () => {
      self.bAutoClose = true;
      self.onNew();
    };

    if (this.$route.params.id != null) {
      const item = {
        ID: this.$route.params.id,
      };
      this.info(item, null, null);
    }
  },
  watch: {
    currentPage: {
      handler() {
        this.getPostData().catch((error) => {
          console.error(error);
        });
      },
    },
  },
};
</script>
<style>
  .tdActionClass{
    width: 120px;
    text-align: center
  }
  .tdText {
    width: 20vw;
  }
  .tdAudio {
    width: 15vw;
  }
  .tdSimbol {
    width: 80px;
  }
</style>
